import { render, staticRenderFns } from "./blacklistDialog.vue?vue&type=template&id=a33d588a&scoped=true"
import script from "./blacklistDialog.vue?vue&type=script&lang=js"
export * from "./blacklistDialog.vue?vue&type=script&lang=js"
import style0 from "./blacklistDialog.vue?vue&type=style&index=0&id=a33d588a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33d588a",
  null
  
)

export default component.exports